import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const { Types, Creators } = createActions({
	// Actions Saga
	audienciaBuscarPorAlertaId: ['alertaId', 'callback'],

	// Actions reducers
	audienciaBuscarPorAlertaIdReducer: ['emissaoAlerta'],
});

export const INITIAL_STATE_VALUES = {
	responsavel: '',
	dataAcao: undefined,
	responsavelEmissao: '',
	dataHoraEmissao: undefined,
	emissaoAlerta: {
		id: 0,
		alertaId: 0,
		crepdecs: [],
		meioComunicacoes: [],
		mensagem: '',
		municipios: [],
		sms: '',
		dataEmissao: '',
		horaEmissao: '',
	},
	dadoParametrizado: {
		categoria: {
			id: 0,
		},
		danosPossiveis: '',
		periodo: undefined,
		dataInicial: undefined,
		horaInicial: undefined,
		dataOcorrencia: undefined,
		horaOcorrencia: '00:00',
		informacoes: '',
		iniciador: {
			id: 0,
		},
		planoContigencia: '',
		severidade: {
			id: 0,
		},
	},
};

const INITIAL_STATE = Immutable(Object.assign({}, INITIAL_STATE_VALUES));

const audienciaBuscarPorAlertaIdReducer = (state = INITIAL_STATE, action) => state.merge({
	responsavel: action.data.responsavel,
	dataAcao: action.data.dataAcao,
	responsavelEmissao: action.data.responsavelEmissao,
	dataHoraEmissao: action.data.dataHoraEmissao,
	emissaoAlerta: {
		...state.emissaoAlerta,
		...action.emissaoAlerta,
		crepdecs: [...action.arrayCrepdecs],
		municipios: [...action.arrayMunicipios],
	},
	dadoParametrizado: {
		...state.dadoParametrizado,
		...action.dadoParametrizado,
	},
});

export default createReducer(INITIAL_STATE, {
	[Types.AUDIENCIA_BUSCAR_POR_ALERTA_ID_REDUCER]: audienciaBuscarPorAlertaIdReducer,
});
